import Rainfall from './rainfall'

export default Rainfall